import {
  InputField,
  PopOver,
  PrimaryHeading,
  SecondaryHeading,
} from "commonUI";
import { CrossIcon } from "allIcons";
import { t } from "i18next";

export default function DeleteModal({
  position = "bottom",
  style = {},
  toolTip = {},
  open = true,
  setOpen,
  inputValue,
  setInputValue,
  deleteTitle = t("common.deletePopup.title"),
  deleteMessage,
  deleteConfirmations,
  deteleConfirmationsClasses,
  onDelete,
  deleteButtonText = t("common.deletePopup.deleteButton.yes"),
  isDeleteButton = false,
  confirmInputTitle,
  disabledDelete = false,
  onClose = () => {},
}) {
  const getButtonClass = () => {
    let className = "py-2 w-full mb-3 rounded-5 border-0";
    if (deleteConfirmations) {
      if (deteleConfirmationsClasses) {
        className += " " + deteleConfirmationsClasses;
      } else if (inputValue.trim() === deleteConfirmations) {
        className += " bg-theme-blue cursor-pointer";
      } else {
        className += " cursor-not-allowed bg-theme-gray";
      }
    } else if (isDeleteButton) {
      className += " delete-button-red cursor-pointer";
    } else {
      className += " bg-theme-blue cursor-pointer";
    }
    return (
      className +
      " text-white font-semibold text-14 leading-5" +
      (deleteConfirmations && inputValue.trim() === deleteConfirmations
        ? " disabled"
        : " cursor-pointer")
    );
  };
  return (
    <PopOver
      open={open}
      style={
        position === "top"
          ? {
              width: "350px",
              bottom: "calc(100% + 15px)",
              top: "unset",
              ...style,
            }
          : { width: "350px", ...style }
      }
      toolTip={toolTip}
      onClose={() => {
        onClose();
        setOpen(false);
      }}
    >
      <div
        className="flex justify-between items-center"
        style={{
          margin: "24px 18px 24px 24px",
        }}
      >
        <PrimaryHeading className="leading-6">{deleteTitle}</PrimaryHeading>
        <div className="">
          <CrossIcon
            size="16"
            fill="#4C5866"
            className="cursor-pointer"
            onClick={() => {
              onClose();
              setOpen(false);
            }}
          />
        </div>
      </div>
      <div className="mr-[24px] ml-[24px]">
        <p className="body-text mb-3">{deleteMessage}</p>
        {deleteConfirmations && (
          <>
            <SecondaryHeading className="">
              {confirmInputTitle || t("common.deletePopup.confirmInput.label")}
            </SecondaryHeading>
            <div className="mb-3">
              <InputField
                type="text"
                placeholder={t("common.deletePopup.confirmInput.placeholder")}
                value={inputValue}
                setValue={setInputValue}
                inputDivClass="mb-0"
              />
            </div>
          </>
        )}
        <button
          onClick={async () => {
            const isDeleted = await onDelete();
            if (!isDeleted) {
              setOpen(false);
            }
          }}
          disabled={
            disabledDelete ||
            (deleteConfirmations && inputValue.trim() === deleteConfirmations)
          }
          type="submit"
          className={getButtonClass()}
        >
          {deleteButtonText}
        </button>
      </div>
    </PopOver>
  );
}
